import { render, staticRenderFns } from "./InputLastName.vue?vue&type=template&id=2316d894&"
import script from "./InputLastName.vue?vue&type=script&lang=js&"
export * from "./InputLastName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports